var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_container",style:({ width: _vm.width, height: _vm.height })},[_c('span',{staticClass:"empty_icon el-icon-warning"}),_c('span',{staticClass:"empty_text"},[_vm._v(_vm._s(_vm.emptyText))])])}
var staticRenderFns = []

export { render, staticRenderFns }